const _excluded = ["editorContent", "editorWithHighlightsConfig", "onEditorChange", "modelClass", "modelId", "modelField", "focusOnInit", "onCreateComment", "showTrackChangesControls"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import { apiKey } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { Editor } from '@tinymce/tinymce-react';
import { onCut, onKeyDown, onSelectionChange } from './modules/track_changes/tinyMceEditorHighlightingUtils';
import CommentsView from './modules/comments/CommentsView';

/**
 * Not all tinymce events are supported by tinymce-react.
 * An up to date list of supported events can be seen here: https://github.com/tinymce/tinymce-react/blob/main/src/main/ts/Events.ts
 * Note that we are using tinymce V5.
 * 
 * The up to da
 * @param {*} param0 
 * @returns 
 */

export default function EditorWithChangeHighlights(_ref) {
  let {
      editorContent,
      editorWithHighlightsConfig,
      onEditorChange,
      modelClass,
      modelId,
      modelField,
      focusOnInit = true,
      onCreateComment,
      showTrackChangesControls = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [clipboardData, setClipboardData] = useState(null);
  const [activeEditorInstance, setActiveEditorInstance] = useState(null); // needed for comments

  const tinyMceContainerCss = "\n    .tox-tinymce {\n      flex-grow: 1;\n      height: 500px;\n    }\n\n    .disabled-btn {\n      position: relative !important;\n    }\n\n    .disabled-btn:before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-image: linear-gradient(120deg, #eaee44, #33d0ff);\n      opacity: .7;\n    }\n\n    .TrackChanges-Highlight-Deletion {\n      color: red !important;\n      text-decoration: line-through !important;\n      font-weight: bold !important;\n      display: inline-block;\n    }\n\n    .TrackChanges-Highlight-Addition {\n      color: green !important;\n      font-weight: bold !important;\n      display: inline-block;\n    }\n  ";
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      alignItems: 'stretch',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("style", null, tinyMceContainerCss), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1,
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement(Editor, _extends({
    apiKey: apiKey,
    value: editorContent,
    name: "body",
    onInit: event => {
      if (focusOnInit) {
        // We could also just call setActiveEditorInstance here, but for some reason
        // when we call activeEditorInstance.execCommand('mceCleanup') on that instance, it throws errors.
        // When we call activeEditorInstance.execCommand('mceCleanup') on the instance of the onFocus function, it works fine.
        event.target.getBody().focus();
      }
    },
    onFocus: data => {
      setActiveEditorInstance(data.target);
    },
    onCut: event => {
      onCut(event, activeEditorInstance);
    },
    onEditorChange: (currentValue, editor) => {
      // Must always pass the currentValue comming from the editor.
      // Even if you pass an equal string, that breaks the editiing. it must be the same string instance.
      onEditorChange(currentValue, editor);
    },
    onSelectionChange: (event, editor) => {
      onSelectionChange(event, editor);
    },
    onKeyDown: (event, editor) => {
      try {
        onKeyDown(event, editor, clipboardData, setClipboardData);
      } catch (e) {
        // TypeError
        // Quite possible that we are deleting at the start or at the end of the body and it doesn't make sense to be able to
        console.error(e);
      }
    },
    init: editorWithHighlightsConfig(() => {})
  }, props)))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(CommentsView, {
    editor: activeEditorInstance,
    modelClass: modelClass,
    modelId: modelId,
    modelField: modelField
  })));
}